import React, { ReactNode, useEffect, useState } from 'react';
import { FactoidWrap, Label, Number, Plate, Text, Title } from '../MainPageStyled';
import { Space } from '@gr-monorepo/common/ui';
import { SchoolsApi } from 'api';
import { Api } from 'api/cabmun-api-public';
import plural from 'utils/pluralize';
import { PlateTemplate } from './PlateTemplate';
import LoaderComponent from 'features/shared/Loader';
import { Error } from './Error';

const Factoid = (props: { value: number; label: string[]; text: ReactNode[] }) => {
  return (
    <FactoidWrap>
      <div>
        <Number>{props.value}</Number>
        <Space size={8} inline />
        <Label>{plural(props.value, props.label)}</Label>
      </div>
      <Space size={8} axis="vertical" />
      <Text>{plural(props.value, props.text)}</Text>
    </FactoidWrap>
  );
};

export const School = () => {
  const [pending, setPending] = useState(false);
  const [error, setError] = useState(false);
  const [totals, setTotals] = useState<Api.GetSchoolTotals200Response>();

  useEffect(() => {
    async function fetch() {
      setPending(true);
      try {
        const totals = await SchoolsApi.getSchoolTotals();
        setTotals(totals);
      } catch (e) {
        setError(true);
      }
      setPending(false);
    }

    fetch();
  }, []);

  const schools = totals?.schools_count || 0;
  const registeredTeachers = totals?.reg_teachers_count || 0;
  const activeTeachers = totals?.active_teachers_count || 0;
  if (pending) {
    return (
      <PlateTemplate title="Основные показатели" dataQaId="basic_indicators_block" link="/schools" name="schools">
        <LoaderComponent color={'#825AF7'} />
        <Space size={211} axis="vertical" />
      </PlateTemplate>
    );
  }

  if (error) {
    return (
      <PlateTemplate title="Основные показатели" dataQaId="basic_indicators_block" link="/schools" name="schools">
        <Error />
        <Space size={150} axis="vertical" />
      </PlateTemplate>
    );
  }
  return (
    <PlateTemplate title="Основные показатели" dataQaId="basic_indicators_block" link="/schools" name="schools">
      <Space size={24} axis="vertical" />
      <Factoid
        value={schools}
        label={['Учебное заведение', 'Учебных заведения', 'Учебных заведений']}
        text={['зарегистрировано на Учи.ру', 'зарегистрировано на Учи.ру', 'зарегистрировано на Учи.ру']}
      />
      <Space size={24} axis="vertical" />

      <Factoid
        value={registeredTeachers}
        label={['Учитель', 'Учителя', 'Учителей']}
        text={[
          <>
            зарегистрирован на Учи.ру
            <br />
            (за текущий год с 1 сентября)
          </>,
          <>
            зарегистрированы на Учи.ру <br />
            (за текущий год с 1 сентября)
          </>,
          <>
            зарегистрированы на Учи.ру <br />
            (за текущий год с 1 сентября)
          </>,
        ]}
      />
      <Space size={24} axis="vertical" />

      <Factoid
        value={activeTeachers}
        label={['Учитель', 'Учителя', 'Учителей']}
        text={[
          activeTeachers === 1 ? (
            <>
              в классах которого есть ученики,
              <br /> занимавшиеся в последние 30 дней
            </>
          ) : (
            <>
              в классах которых есть ученики, <br /> занимавшиеся в последние 30 дней
            </>
          ),
          <>
            в классах которых есть ученики, <br />
            занимавшиеся в последние 30 дней
          </>,
          <>
            в классах которых есть ученики, <br />
            занимавшиеся в последние 30 дней
          </>,
        ]}
      />
    </PlateTemplate>
  );
};
